export default {
    middleware: 'tools',

    watch: {
        $auth: {
            handler(val) {
                if (!val.loggedIn) this.$router.replace('/')
            },
        },
    },
}
